
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import FooterServiceNav from "./FooterServiceNav";
import serviceData from "../../components/services/services-one/ServicesOneData.json";

const Footer = ({ siteSettings }) => {
  const [socialLinks, setSocialLinks] = useState(null);

  useEffect(() => {
    const fetchSocialLinks = async () => {
      try {
        const response = await fetch(
          "https://portal.ebs365.info/api/social-links"
        );
        const data = await response.json();
        setSocialLinks(data);
      } catch (error) {
        console.error("Error fetching social links:", error);
      }
    };

    fetchSocialLinks();
  }, []);

  const linksArr = (socialLinks && socialLinks.data) || [];

  const getSiteUrl = (index) =>
    linksArr[index] && linksArr[index].site_url
      ? linksArr[index].site_url
      : " ";

  const facebook = getSiteUrl(4);
  const twitter = getSiteUrl(3);
  const instragram = getSiteUrl(2);
  const yoytube = getSiteUrl(1);
  const linkedIn = getSiteUrl(0);

  const info = (siteSettings && siteSettings.data) || {};
  const offices = info.offices || [];
  const secondOfficeEmail =
    offices[0] && offices[0].email ? offices[0].email : "";

  return (
    <>
      {/* footer Section Start */}
      <footer>
        {/* footer Top Section Start */}
        <div className="footer-sec">
          <div className="container">
            <div className="row">
              <div className="col-md-3 col-sm-6">
                <div className="logo">
                  <Link to="/">
                    <img
                      src={info.logo ? info.logo : "/images/no-image.png"}
                      width={200}
                      height={20}
                      alt="Logo"
                    ></img>
                  </Link>
                </div>
                <div className="footer-wedget-one">
                  <p className="footer-item">{info.description || ""}</p>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="footer-widget-menu">
                  <h2>Service links</h2>
                  <ul>
                    {serviceData.map((item) => (
                      <FooterServiceNav key={item.id} data={item} />
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="footer-widget-menu">
                  <h2>Support links</h2>
                  <ul>
                    <li>
                      <a href="#">about us</a>
                    </li>
                    <li>
                      <a href="#">Employees</a>
                    </li>
                    <li>
                      <a href="#">Contact Us</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="footer-wedget-four">
                  <h2>contact us </h2>
                  <div className="inner-box">
                    <div className="inner-item">
                      <div className="media">
                        <div className="media-left">
                          <span className="icon">
                            <i className="fa fa-map-marker" />
                          </span>
                        </div>
                        <div className="media-body">
                          <span className="inner-text">
                            {info.address || ""}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="inner-item">
                      <div className="media">
                        <div className="media-left">
                          <span className="icon">
                            <i className="fa fa-envelope-o" />
                          </span>
                        </div>
                        <div className="media-body">
                          <span className="inner-text">
                            {info.email ? (
                              <a
                                href={`mailto:${info.email}`}
                                style={{
                                  textDecoration: "none",
                                  color: "inherit",
                                }}
                              >
                                {info.email}
                              </a>
                            ) : (
                              ""
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    {/* <div className="inner-item">
                      <div className="media">
                        <div className="media-left">
                          <span className="icon">
                            <i className="fa fa-envelope-o" />
                          </span>
                        </div>
                        <div className="media-body">
                          <span className="inner-text">
                            {secondOfficeEmail ? (
                              <a
                                href={`mailto:${secondOfficeEmail}`}
                                style={{
                                  textDecoration: "none",
                                  color: "inherit",
                                }}
                              >
                                {secondOfficeEmail}
                              </a>
                            ) : (
                              ""
                            )}
                          </span>
                        </div>
                      </div>
                    </div> */}
                    <div className="inner-item">
                      <div className="media">
                        <div className="media-left">
                          <span className="icon">
                            <i className="fa fa-phone" />
                          </span>
                        </div>
                        <div className="media-body">
                          <span className="inner-text">
                            {info.phone ? (
                              <a
                                href={`tel:${info.phone}`}
                                style={{
                                  textDecoration: "none",
                                  color: "inherit",
                                }}
                              >
                                {info.phone}
                              </a>
                            ) : (
                              ""
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* footer Top Section End */}
        {/* footer Bottom Section Start */}
        <div className="footer-bottom-sec">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="copy-right">
                  <p>
                    © Copyright 2026{" "}
                    <span>
                      <a href="#">RSS Security and Investigations Pty Ltd.</a>
                    </span>{" "}
                    <span> to deliver the protection you deserve!</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* footer Bottom Section End */}
      </footer>
      {/* footer Section End */}
    </>
  );
};

export default Footer;
